import TitleField from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningForm/TitleField";
import AliasField from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningForm/AliasField";
import ErrorsCatcher from "@/components/ErrorsCatcher/Tsx/ErrorsCatcher";
import ActiveSelector
    from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningForm/ActiveSelector";

function CreateOrEditFileMeaningForm() {
    return (
      <>
          <ErrorsCatcher errorId="efd12f57-449f-473e-bbdb-f10d8b55086f">
              <TitleField/>
          </ErrorsCatcher>

          <ErrorsCatcher errorId="f9519b34-0ef5-49be-b7a8-06d1900c81c6">
              <AliasField/>
          </ErrorsCatcher>

          <ErrorsCatcher errorId="a6962a2c-7d22-4f4b-ba75-f0f977e9b4dc">
              <ActiveSelector/>
          </ErrorsCatcher>
      </>
    );
}

export default CreateOrEditFileMeaningForm;
